import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import disableDevtool from'disable-devtool';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

disableDevtool();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
